import React from "react";
import { Link } from "react-router-dom";
import { WHATSAPP_LINK, openWhatsApp } from "@/data/site";
import { useT } from "@/context/LanguageContext";
import { ArrowRight, WhatsappLogo } from "@phosphor-icons/react";

export function CTASection() {
  const { t } = useT();
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#1E73BE] to-[#16B894] py-20 lg:py-24" data-testid="cta-section">
      <div className="absolute inset-0 grain opacity-10" />
      <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
        <h2 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl text-balance">
          {t("cta.title")}
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/90">
          {t("cta.subtitle")}
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/contact?type=quote"
            data-testid="cta-request-quote"
            className="group flex items-center gap-2 rounded-md bg-white px-8 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:-translate-y-0.5"
          >
            {t("cta.requestQuote")}
            <ArrowRight size={18} weight="bold" className="transition-transform group-hover:translate-x-1" />
          </Link>
          <a
            href={WHATSAPP_LINK}
            onClick={openWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp"
            className="flex items-center gap-2 rounded-md border border-white/40 bg-white/10 px-8 py-3.5 text-sm font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/20"
          >
            <WhatsappLogo size={20} weight="fill" /> {t("cta.whatsapp")}
          </a>
        </div>
      </div>
    </section>
  );
}
